import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import GeoIntroduction from "./GeoIntroduction";
import GeoConsoleUserGuide from "./GeoConsoleUserGuide";
import GeoIntegrationProcess from "./GeoIntegrationProcess";
import GeoOverviewOne from "./GeoOverviewOne";
import GeoSdkIntegrationIos from "./GeoSdkIntegrationIos";
import GeoSdkIntegrationAndroid from "./GeoSdkIntegrationAndroid";
import GeoSdkIntegrationReactNative from "./GeoSdkIntegrationReactNative";
import GeoSdkIntegrationXamarin from "./GeoSdkIntegrationXamarin";
import GeoSdkIntegrationWeb from "./GeoSdkIntegrationWeb";
import GeoVerifyOverview from "./GeoVerifyOverview";
import GeoBackendIntegration from "./GeoBackendIntegration";
import BuildWithLlm from "../BuildWithLlm";
import { geoTabs } from "./GeoTabs";
import geoBuildWithLlmFile from "../../../assets/markDownFiles/geosafe/build_with_llm.md";
import verifyBuildWithLlmFile from "../../../assets/markDownFiles/verify/build_with_llm.md";

// Panels are keyed by SLUG, not by array position, so adding/removing a tab in
// `geoTabs` can never leave the panels misaligned with the tabs.
const panelsBySlug = {
  "advanced-compliance-technology": <GeoIntroduction />,
  "admin-console": <GeoConsoleUserGuide />,
  onboarding: <GeoIntegrationProcess />,
  "geo-overview": <GeoOverviewOne />,
  "sdk-ios": <GeoSdkIntegrationIos />,
  "sdk-android": <GeoSdkIntegrationAndroid />,
  "sdk-react-native": <GeoSdkIntegrationReactNative />,
  "sdk-xamarin": <GeoSdkIntegrationXamarin />,
  "geo-build-with-llm": <BuildWithLlm file={geoBuildWithLlmFile} product="ACT Geosafe" />,
  "verify-overview": <GeoVerifyOverview />,
  "sdk-web": <GeoSdkIntegrationWeb />,
  "web-backend-integration": <GeoBackendIntegration />,
  "verify-build-with-llm": (
    <BuildWithLlm file={verifyBuildWithLlmFile} product="ACT Geosafe (Web)" />
  ),
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      sx={{
        height: "100vh",
        overflowY: "auto",
        boxSizing: "border-box",
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function GeoTabPanels({ value }) {
  // Derive the rendered panels from the tabs themselves, in tab order.
  const contentTabs = geoTabs.filter((t) => !t.isHeader);

  return (
    <>
      {contentTabs.map((tab, index) => (
        <TabPanel key={tab.slug} value={value} index={index}>
          {panelsBySlug[tab.slug] ?? null}
        </TabPanel>
      ))}
    </>
  );
}

export default GeoTabPanels;
